export default __webpack_public_path__ + "static/media/cp_geo_gf.99b4d16d.svg";